export default {
    //去掉html标签只留文本
    removeLab(str) {
        return str.replace(/<[^>]+>|&[^>]+;/g, "");
    },
    //限制文本字数
    limitNum(str, num) {
        // console.log(str, num)
        if (str) {
            return str.substr(0, num) + "..."
        }

    },
    //获取当前时间
    getTime() {
        let data = new Date();
        let year = data.getFullYear();
        let month = data.getMonth() + 1;
        let day = data.getDate();
        let hours = data.getHours();
        let minutes = data.getMinutes();
        let seconds = data.getSeconds();
        return year + "-" + (month < 10 ? ("0" + month) : month) + "-" + (day < 10 ? ("0" + day) : day) + " " + (hours < 10 ? ("0" + hours) : hours) + ":" + (minutes < 10 ? ("0" + minutes) : minutes) + ":" + (seconds < 10 ? ("0" + seconds) : seconds)
    },
    /**
     * 搜索关键字过滤 添加高亮
     *
     * @param    {String}  keyword   替换的关键字
     * @param    {String}  data   替换的内容
     * @author
     */
    keywordShow(data) {
        let keyword = ['铝矾土', '棕刚玉', '白刚玉', '烧结刚玉', '碳化硅']
        let result = data
        for (var j = 0; j < keyword.length; j++) {
            let subStr = new RegExp(keyword[j], "ig")
            result = result.replace(
                subStr,
                `<span style="color:#e70012">${keyword[j]}</span>`
            )
        }
        return result;
    },

}